/******/ (function() { // webpackBootstrap
/******/ 	"use strict";
var __webpack_exports__ = {};

/******/ })();

$(document).ready(function() {
  if($('#search_blogs_box_input').length){
    function search_content($this) {
      $("body").addClass("pageloding");
        var searchTerm = $this.val();
        var url = 'https://energylounger.com/search?q=' + encodeURIComponent(searchTerm) + '&type=article';
        window.location.href = url;
        // var xhr = new XMLHttpRequest();
        // xhr.open('GET', url, true);
        // xhr.onreadystatechange = function() {
        //   if (xhr.readyState === 4 && xhr.status === 200) {
        //     var parser = new DOMParser();
        //     var htmlDoc = parser.parseFromString(xhr.responseText, 'text/html');
        //     var articles = htmlDoc.querySelector('#CollectionProductGrid .search_data_section').innerHTML;
        //     //console.log(articles);
        //     $(".multi_block_sections").addClass("no_more_show");
        //     $("section.main_blog_section .multi_block_sections .artica_blogs").html("").append(articles);
        //     $("body").removeClass("pageloding");
        //   }
        // };
        // xhr.send();
    }
    $("#search_blogs_box_button").click(function() {
        //console.log($("#search_blogs_box_input").val());      
        if($("#search_blogs_box_input").val() != ""){
          search_content($("#search_blogs_box_input"));
        }else{
          $(".multi_block_sections").removeClass("no_more_show");
          $(".template-search__results").remove();
        }
    });
    $("#search_blogs_box_input").change(function() {
        //console.log($(this).val());      
        if($(this).val() != ""){
          search_content($(this));
        }else{
          $(".multi_block_sections").removeClass("no_more_show");
          $(".template-search__results").remove();
        }
    });    
  }
});